export default class NavigateTo {
  constructor(context) {
    this.context = context;
  }

  run(location) {
    this.context.router.navigateTo(location);
  }
}
